import { ObjectField, TextField, TimestampField } from "~/components/Form";
import {
  LabelSelectField,
  NewLqsResourceForm,
  TopicSelect,
  useCreateTag,
} from "~/lqs";
import { makeTagLocation, useLogParams } from "~/paths";
import { createTagSchema } from "../schemas";

export function TagCreateForm() {
  const { logId } = useLogParams();

  return (
    <NewLqsResourceForm
      schema={createTagSchema}
      defaultValues={{
        labelId: null,
        topicId: null,
        note: null,
        startTime: null,
        endTime: null,
        context: null,
      }}
      resourceName="tag"
      mutation={useCreateTag(logId)}
      createDetailsLocation={(response) =>
        makeTagLocation({ logId, tagId: response.data.id })
      }
    >
      {(control) => (
        <>
          <LabelSelectField control={control} name="labelId" required />
          <TopicSelect control={control} name="topicId" logId={logId} />
          <TextField control={control} name="note" />
          <TimestampField control={control} name="startTime" />
          <TimestampField control={control} name="endTime" />
          <ObjectField control={control} name="context" />
        </>
      )}
    </NewLqsResourceForm>
  );
}
